import { render, staticRenderFns } from "./IconInStockAndReady.vue?vue&type=template&id=49504234&scoped=true&"
var script = {}
import style0 from "./IconInStockAndReady.vue?vue&type=style&index=0&id=49504234&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49504234",
  null
  
)

export default component.exports